import { FloatingFormItem, InputDecimal } from '@/components/_common';
import { BankAccount } from '@/core/domain/enterprise/BankAccounts/BankAccounts.types';
import { BankAccountSettingsFormValues } from '@/core/domain/enterprise/BankAccountsSettings/BankAccountsSettings.types';
import { Col, Form, FormInstance, Row, Select } from 'antd';

interface Props {
  form: FormInstance<BankAccountSettingsFormValues>;
  bankAccount?: BankAccount;
}

export default function ConfigBankSlipProtestForm({ form }: Props) {
  const titleProtestCodeOptions = [
    { value: '1', label: 'Protestar Dias Corridos' },
    { value: '2', label: 'Protestar Dias Úteis' },
    { value: '3', label: 'Não Protestar' },
    { value: '4', label: 'Protestar Fim Falimentar - Dias Úteis' },
    { value: '5', label: 'Protestar Fim Falimentar - Dias Corridos' },
    { value: '8', label: 'Negativação sem Protesto' },
    {
      value: '9',
      label:
        'Cancelamento Protesto Automático (somente válido p/ Código Movimento Remessa = 31)',
    },
  ];

  return (
    <Form form={form} name="bankAccountConfigBullet">
      <Row gutter={[12, 12]}>
        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Código protesto"
            name={['protest', 'titleProtestCode']}
          >
            <Select
              allowClear
              style={{ width: '100%' }}
              options={titleProtestCodeOptions}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={12} lg={6} xxl={4}>
          <FloatingFormItem
            label="Prazo protesto"
            name={['protest', 'titleProtestTerm']}
          >
            <InputDecimal fractions={0} />
          </FloatingFormItem>
        </Col>
      </Row>
    </Form>
  );
}
